import { FaSearch, FaUserMd } from "react-icons/fa";
import { alpha, styled } from "@mui/material";
import { StyledComponent } from "@emotion/styled";

import colors from "../../../styles/colors/colors";
import others from "../../../styles/colors/others";
import { NppesTableHeadColor } from "../../../styles/common/style";
import { flexAllCentre } from "../../../styles/mui/styles/display";

export const NppesOuterBodyGrid = () => ({
  backgroundColor: colors.backgroundColor[7],
  opacity: 1,
  padding: "0.8rem 0.5rem",
  borderRadius: "0.8rem",
  width: "100%",
});

export const NppesNameStyle = {
  paddingLeft: "2rem",
  paddingTop: "0.55rem",
};
export const SearchNpiContainer = () => ({
  maxWidth: "100%",
});

export const NppesStateSearchWidth = {
  minWidth: "12rem",
};

export const NppesErrorMsgStyle = {
  width: "max-content",
};

export const NppesAutocompleteUI = () => ({
  width: "25rem",
  position: "relative",
  "& .MuiInput-input": {
    WebkitBoxShadow: `0 0 0 62.5rem ${colors.backgroundColor[9]} inset`,
  },
});

export const IconFaUser: StyledComponent<any> = styled(FaUserMd as React.ComponentType)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "left",
  color: colors.primary.main,
  margin: "0 0.6rem 0.23rem 0",
}));

export const NppesAutoComplete = {
  width: "100%",
  borderBottom: others.otherColors[35],
  borderBottomWidth: "0.06rem",
  marginRight: "1.5rem",
};

export const Search = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const IconFaSearch: StyledComponent<any> = styled(FaSearch as React.ComponentType)(() => ({
  display: "flex",
  color: alpha(colors.fonts[4], 0.32),
  justifyContent: "left",
}));

export const DatePickerInput = () => ({
  "& .MuiInput-input": {
    WebkitBoxShadow: `0 0 0 62.5rem ${colors.backgroundColor[9]} inset`,
  },
});

export const TablecellStyle = {
  borderBottom: "none",
};

export const NppesAutoCompleteNameInputMargin = () => ({ marginTop: "0.5rem" });

export const rowMaxWidth = { maxWidth: "54.625rem" };

// below width equals to rowMaxWidth
const nameBoxWidth = "20rem";
const npiBoxWidth = "10rem";
const addressBoxWidth = "24.625rem";
const buttonBoxWidth = "10rem";

const headerRowHeight = "2.813rem";
const bodyRowHeight = "2.913rem";
const rowWidth = "100%";
const textTransform = "capitalize";

const paddingLeft = "1rem";

export const NppesContainer = {
  header: {
    row: {
      minHeight: headerRowHeight,
      width: rowWidth,
      ...NppesTableHeadColor,
      ...flexAllCentre(),
      marginBottom: "0.5rem",
    },
    cell1: {
      width: nameBoxWidth,
      paddingLeft,
      textTransform,
    },
    cell2: {
      width: npiBoxWidth,
      paddingLeft,
      textTransform,
    },
    cell3: {
      width: addressBoxWidth,
      paddingLeft,
      textTransform,
    },
    cell4: {
      width: buttonBoxWidth,
      paddingLeft: "3rem",
      textTransform,
    },
  },
  body: {
    row: {
      height: bodyRowHeight,
      width: rowWidth,
      ...flexAllCentre(),
    },
    cell1: {
      width: nameBoxWidth,
      paddingLeft,
      textTransform,
    },
    cell2: {
      width: npiBoxWidth,
      paddingLeft,
      textTransform,
    },
    cell3: {
      width: addressBoxWidth,
      paddingLeft,
      textTransform,
      wordBreak: "break-word",
    },
    cell4: {
      width: buttonBoxWidth,
      textTransform,
    },
  },
};

export const NppesParentElementStyle = {
  position: "relative"
};